import { css } from '@emotion/react'
import { typography } from '@lifedot/styles/typography'
import { FC } from 'react'

const styles = {
  feature: css({
    paddingLeft: 20,
    li: {
      listStyle: 'initial'
    }
  })
}

interface FeaturesProps {
  labels: string[]
}

export const Features: FC<FeaturesProps> = ({ labels }) => {
  return (
    <ul css={[typography.textS, styles.feature]}>
      {labels.map((name) => (
        <li key={name}>{name}</li>
      ))}
    </ul>
  )
}
